import { render, staticRenderFns } from "./recycle_flag.vue?vue&type=template&id=324f3bec&"
import script from "./recycle_flag.vue?vue&type=script&lang=js&"
export * from "./recycle_flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports